import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Breakpoint, ConditionalWrapper, Image as AndesImage, TextAlpha, Box, } from '@yonderland/andes-react';
import { useState } from 'react';
const CAPTION_BG_COLOR = 'opacity-dark';
const TRANSITION_DURATION = 300;
const TRANSITION_SCALE = 1.025;
const TRANSITION_TIMING = 'ease-out';
const Image = ({ fileReference, alt = '', caption, captionPosition = 'below', lazyLoad = false, link, target, hideOnMobile = false, analyticsId, }) => {
    const [isHovered, setIsHovered] = useState(false);
    const boxProps = captionPosition === 'below'
        ? { paddingBlock: '2' }
        : { position: 'absolute', bottom: '0', left: '0', backgroundColor: CAPTION_BG_COLOR, padding: '2' };
    const textProps = {
        as: 'span',
        variant: 'bodyXS',
        color: captionPosition === 'below' ? 'subtle' : 'on-media',
        children: caption,
    };
    const imageContainer = (_jsxs("div", { className: "a:h-full a:flex a:relative a:flex-col", children: [_jsx(Box, { display: "flex", overflow: "hidden", children: _jsx(AndesImage, { lazyLoad: lazyLoad, source: fileReference, alt: alt, asCover: true, style: {
                        transform: `scale(${isHovered ? TRANSITION_SCALE : 1})`,
                        transition: `transform ${TRANSITION_DURATION}ms ${TRANSITION_TIMING}`,
                    } }) }), caption && (_jsx(Box, Object.assign({}, boxProps, { children: _jsx(TextAlpha, Object.assign({}, textProps)) })))] }));
    const content = link ? (_jsx("a", { href: link, target: target, rel: target === '_blank' ? 'noopener noreferrer' : undefined, onMouseEnter: () => setIsHovered(true), onMouseLeave: () => setIsHovered(false), children: imageContainer })) : (imageContainer);
    return (_jsx(ConditionalWrapper, { condition: hideOnMobile, wrapper: children => _jsx(Breakpoint, { from: "md", children: children }), children: _jsx(ConditionalWrapper, { condition: !!analyticsId, wrapper: children => _jsx("div", { "data-analytics-bannerid": analyticsId, children: children }), children: content }) }));
};
export default Image;
